import dayjs from "dayjs";

import { useMemo } from "react";

import { Timeline } from "@mui/icons-material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";
import NotificationAddIcon from "@mui/icons-material/NotificationAdd";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import { Button, Card, CardContent, Switch, Tooltip, Typography } from "@mui/material";

import usePlatform from "@/hooks/usePlatform";

const TrackPrice = (props: {
  dateRange: number[];
  value: boolean;
  onChange: (v: boolean) => void;
  onRouteRequest: (v: boolean) => void;
}) => {
  const { isPc } = usePlatform();
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.onChange(event.target.checked);
  };

  const dateRangeText = useMemo(() => {
    let dateStr;
    const [start, end] = props.dateRange;

    if (start < end) {
      if (dayjs(start).isSame(end, "M")) {
        dateStr =
          dayjs(start).format("MMM") +
          " " +
          dayjs(start).format("DD") +
          "-" +
          dayjs(end).format("DD");
      } else {
        dateStr =
          dayjs(start).format("MMM") +
          " " +
          dayjs(start).format("DD") +
          " - " +
          dayjs(end).format("MMM") +
          " " +
          dayjs(end).format("DD");
      }
    } else {
      dateStr = dayjs(start).format("MMM") + " " + dayjs(start).format("DD");
    }

    if (dateStr.toLowerCase().includes("invalid")) {
      return "";
    }
    return dateStr;
  }, [props.dateRange]);

  const TrackPricePC = (
    <div className="flex items-center">
      <InsightsOutlinedIcon color="primary" />
      <div className="flex items-center mx-[10px]">
        <Typography variant="body1" color="textPrimary" sx={{ fontWeight: "bold" }}>
          Track prices
        </Typography>

        <Tooltip
          sx={{ size: 10 }}
          title="Get email and SMS updates when prices change for your searched dates. You'll also get travel
                tips by email."
        >
          <InfoOutlinedIcon sx={{ fontSize: 16, marginLeft: "4px" }} color="primary" />
        </Tooltip>
      </div>

      <div className="flex items-center">
        <Typography variant="body1" color="primary">
          {dateRangeText}
        </Typography>
        <Switch
          inputProps={{ "aria-label": "controlled" }}
          checked={props.value}
          onChange={handleChange}
        />
        <NotificationsActiveIcon color="primary" />
      </div>

      <div className="flex-1" />

      <Button
        variant="contained"
        size="small"
        startIcon={<ThumbUpOffAltIcon />}
        onClick={() => props.onRouteRequest(true)}
      >
        Add Route
      </Button>
    </div>
  );

  const TrackPriceMobile = (
    <Card className="pb-[1px]" elevation={1}>
      <CardContent
        className="flex items-center"
        sx={{
          marginTop: -1,
          paddingTop: 2,
          ":last-child": {
            paddingBottom: 1,
          },
        }}
      >
        <Timeline color="primary" />
        <div className="ml-[10px]">
          <Typography variant="body1" color="textPrimary">
            Track prices
          </Typography>
          <Typography variant="body1" color="primary">
            {dateRangeText}
          </Typography>
        </div>
        <Switch
          inputProps={{ "aria-label": "controlled" }}
          checked={props.value}
          onChange={handleChange}
        />

        <div className="flex-1" />

        <div>
          <Button
            variant="contained"
            size="small"
            startIcon={<ThumbUpOffAltIcon />}
            onClick={() => props.onRouteRequest(true)}
          >
            Add Route
          </Button>
        </div>
      </CardContent>
    </Card>
  );

  return isPc ? TrackPricePC : TrackPriceMobile;
};

export default TrackPrice;
